<template>
    <div id="container">
    </div>
</template>

<script>
import * as Cesium from "cesium/Cesium";
import * as widgets from "cesium/Widgets/widgets.css";

window.viewer = null
window.Cesium = Cesium
window.earth = null
window.convenient = null
import InitCesium from './js/initCesium'
import Convenient from './js/convenient'
import Tiles from './js/model'
export default {
    data(){
        return {
            tileset:null,
            tile:new Tiles()
        }
    },
    mounted(){
        this.init()
    },
    methods:{
        init(){
            Cesium.Ion.defaultAccessToken =
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyYjZjYWUyZi00YWRkLTRjMjUtYmNmNC0xMWViMjgxYjI4MDgiLCJpZCI6NjYxMjEsImlhdCI6MTYzMDY1MzcxN30.GTEf3cn_2IGsuOoqIuznPJ_D8py8PUt97UG7THjymnc';
            earth = new InitCesium('container', {
                skyAtmosphere: false,
                shouldAnimate : true,
                terrainProvider: Cesium.createWorldTerrain()
            });
            viewer.scene.globe.depthTestAgainstTerrain = true;
            convenient = new Convenient({viewer})
            // convenient.fly({
            //     x: -465240.9663252326, y: 5515672.145114674, z: 3204053.269182405,
            //     heading :0.3547449306411945,
            //     pitch:-0.606743277236669,
            //     roll: 0.00017783217350419989
            // })
            this.addThreeTiles()
            this.earthTransparent()
            this.addSiteTiles()
        },
        addThreeTiles(){
            let tileset = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
                url:'/CSKT/tileset.json',
                maximumScreenSpaceError: 1,
                maximumMemoryUsage: 2048,
            }))
            let _this = this
            tileset.readyPromise.then(function(tileset){
                let boundingSphere = tileset.boundingSphere
                let cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center)
                let surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude,0)
                let offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, -15)
                let translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
                tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
                
                // 以3dtiles的原点制定坐标系
                let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(boundingSphere.center)
                console.log(modelMatrix);
                let _modelPrimitive = new Cesium.DebugModelMatrixPrimitive({modelMatrix:modelMatrix})
                viewer.scene.primitives.add(_modelPrimitive)


                let boundingSpherenew = new Cesium.BoundingSphere(
                    new Cesium.Cartesian3(-2237010.470742977,5020685.483528398,3224755.5977839613),100
                )
                //裁切
                let aaa = convenient._clipPlanes({
                    left : -20,
                    right: -40,
                    before : 60,
                    after : -120,
                    up : -5,
                    down:-10
                    // left : -20,
                    // right: -20,
                    // before : -20,
                    // after : -20,
                    // up : -20,
                    // down:-20,
                })
                tileset.clippingPlanes = aaa
                let arr = aaa
                for(let i = 0;i<arr.length;i++){
                    let palne = arr._planes[i]
                    console.log(palne);
                    let planeEntity = viewer.entities.add({
                        name:'平面' + i,
                        position:boundingSphere.center,
                        plane:{
                            dimensions:new Cesium.Cartesian2(40, 40),
                            material:Cesium.Color.BLUE.withAlpha(0.1),
                            plane:palne,
                            outline:true,
                            outlineColor:Cesium.Color.WHITE
                        }
                    })
                }

                _this.clip()

            })
            // viewer.zoomTo(tileset)
            this.tileset  = tileset

            // // 以一个固定点添加坐标系
            // let position = Cesium.Cartesian3.fromDegrees(114.0152479612167,30.568806803530364,9.313225746154785e-10)
            // let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(position)
            // let _modelPrimitive = new Cesium.DebugModelMatrixPrimitive({modelMatrix:modelMatrix})
            // viewer.scene.primitives.add(_modelPrimitive)
            
            
        },
        
        clip(){  // 裁切地形
            var globe = viewer.scene.globe;
            let _this = this
            let position = new Cesium.Cartesian3.fromDegrees(114.01520854685607, 30.568023784356374, 0)

            let entity = viewer.entities.add({
                position : position,
                box : {
                    dimensions : new Cesium.Cartesian3(40.0, 40.0, 80.0),
                    material : Cesium.Color.WHITE.withAlpha(0.3),
                    outline : true,
                    outlineColor : Cesium.Color.WHITE
                }
            });

            globe.depthTestAgainstTerrain = true;
            
            let palnes = convenient._clipPlanes({
                    left : -30,
                    right: -30,
                    before : -20,
                    after : -20,
                    up : -20,
                    down:-20,
                    modelMatrix:entity.computeModelMatrix(Cesium.JulianDate.now())
                })
            globe.clippingPlanes = palnes
        },
        addSiteTiles(){
            let tile = this.tile.addThreeTiles({
                url:'/lutaidalou3Dtiles/tileset.json',
                name : '3dTiles',
                positionModel : {
                    lon:114.01520854685607,
                    lat:30.568023784356374,
                    alt:-51
                },
                scaleNum :50
            })
            viewer.zoomTo(tile.tiles)
            this.siteTile = tile.tiles
        },
        earthTransparent(){
            // 禁用相机对地形的碰撞检测 
            viewer.scene.screenSpaceCameraController.enableCollisionDetection = false;
            viewer.scene.globe.translucency.frontFaceAlphaByDistance = new Cesium.NearFarScalar(
                10,
                0.3,
                100.0,
                1.0
                );
            // 开启地表透明效果
            viewer.scene.globe.translucency.enabled  = true
            console.log(viewer.scene);
            // viewer.scene.skyAtmosphere = new Cesium.SkyAtmosphere();

            // viewer.scene.skyAtmosphere.show = false;
            // viewer.scene.globe.showGroundAtmosphere = false
            // viewer.scene.globe.baseColor = Cesium.Color.TRANSPARENT
            // viewer.scene.globe.undergroundColor = undefined
            // viewer.scene.globe.undergroundColor = 'rgba(0, 0, 0, 0)'
            viewer.scene.undergroundMode = true
            viewer.scene.skyBox.show = false
            // viewer.scene.underGlobe.baseColor = new Cesium.Color(0, 0, 0, 0)
            viewer.scene.globe.baseColor = new Cesium.Color(0, 0, 0, 0.0)
            viewer.scene.backgroundcolor = new Cesium.Color(0, 0, 0, 0)

        }
    }
}
</script>

<style scoped lang="less">
#container{
    width: 80vw;
    height: 100vh;
    z-index: 0;
}
</style>